import { render, staticRenderFns } from "./mobileAbout.vue?vue&type=template&id=70a2b224&scoped=true&"
import script from "./mobileAbout.vue?vue&type=script&lang=js&"
export * from "./mobileAbout.vue?vue&type=script&lang=js&"
import style0 from "./mobileAbout.vue?vue&type=style&index=0&id=70a2b224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2b224",
  null
  
)

export default component.exports